module.exports = __webpack_public_path__ + "img/document-code-2.d6572605.svg";